module.exports = __webpack_public_path__ + "img/Vector.c33cb683.svg";